import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';

export function PrintPortal({ children }: { children: React.ReactNode }) {
  const elRef = useRef<HTMLDivElement | null>(null);
  if (!elRef.current) {
    elRef.current = document.createElement('div');
    elRef.current.style.display = 'none';
  }

  useEffect(() => {
    document.body.appendChild(elRef.current!);
    return () => {
      document.body.removeChild(elRef.current!);
    };
  }, []);

  return createPortal(children, elRef.current);
}
